import { Component, input } from '@angular/core';
import { CustomerAccountType } from 'src/app/_enums/customer-account-type.enum';

/**
 * One pill after the record's id: a branch with its icon, an insurer with its
 * logo — or, given a modifier, a plain tinted `lty-badge` such as the pink
 * « Demande de résiliation ».
 */
export type DetailsHeaderBadge = {
  label: string;
  iconUrl?: string | null;
  /** Draws `iconUrl` as an insurer logo (height-capped) rather than a glyph. */
  logo?: boolean;
  /** An `lty-badge` modifier (`pink`, `success`…) instead of the uppercase insurance pill. */
  modifier?: string;
};

/**
 * The strip at the top of a record's slide-in: its id and badges on one line,
 * the customer on the next. Shared by the insurance-flow and cancellation
 * modals, which differ only in what they put in the badges.
 */
@Component({
  selector: 'app-details-header',
  standalone: true,
  templateUrl: './details-header.component.html',
  styleUrl: './details-header.component.css',
})
export class DetailsHeaderComponent {
  readonly displayId = input.required<string>();

  readonly badges = input<DetailsHeaderBadge[]>([]);

  readonly customerName = input<string | null>(null);

  readonly customerDisplayId = input<string | null>(null);

  /** `User.type`, a string on the wire; compared to the account-type values. */
  readonly accountType = input<string | null>(null);

  readonly isClient = input(false);

  protected readonly CustomerAccountType = CustomerAccountType;
}
